var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', [_vm._v("OOPS!")]), _c('ul', [_c('li', [_c('span', [_vm._v("route path:")]), _vm._v("\n      " + _vm._s(_vm.$route.path) + "\n    ")]), _c('li', [_c('span', [_vm._v("route params:")]), _vm._v("\n      " + _vm._s(_vm._f("json")(_vm.$route.params)) + "\n    ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }